import { getDatasetType, getSchemeFromTilesetDataset } from 'features/builder/state/builderSliceUtils'
import { KeplerTable, LayerTypes, TilingScheme } from 'features/builder/types'
import { MapType } from 'features/maps/types'
import IconH3 from 'assets/icons/layers/hexagonId.svg?react'
import SpatialIndexLayer from './SpatialIndexLayer'

export default class H3Layer extends SpatialIndexLayer {
  public get type() {
    return LayerTypes.H3
  }

  get name() {
    return 'H3'
  }

  get layerIcon() {
    return IconH3
  }

  static findDefaultLayerProps(dataset: KeplerTable, foundLayers) {
    const emptyProps = { props: [] }

    if (foundLayers?.length) {
      return emptyProps
    }
    const scheme = getSchemeFromTilesetDataset(dataset)

    if (getDatasetType(dataset) === MapType.tileset && scheme === TilingScheme.H3) {
      return {
        props: [
          {
            label: dataset.label,
            isVisible: true,
            columns: {}
          }
        ]
      }
    }
    return emptyProps
  }
}
